import { getPrettyName } from "common/helpers/Pretty";
import { titleCaseString } from "common/helpers/String";
import { IdType, Nullable } from "common/types";
import { List, Record } from "immutable";

export const fromJSON = (json: Partial<IDropdownData>): DropdownRecord => {
  const record: IDropdownRecord = { ...(json as any) };
  return new DropdownRecord(record);
};

export const fromList = (list: List<IdType>, usePrettyName = false): List<DropdownRecord> => {
  return list.map((item) =>
    fromJSON({
      id: item,
      name: usePrettyName ? getPrettyName(item.toString()) : item.toString(),
    }),
  );
};

export interface IDropdownData {
  id: Nullable<IdType | boolean>;
  name: string;
}

export interface IDropdownRecord {
  id: Nullable<IdType | boolean>;
  name: string;
}

export const defaultDropdownProps = {
  id: -1,
  name: "",
};

export class DropdownRecord extends Record<IDropdownRecord>(defaultDropdownProps) implements IDropdownRecord {}
